import * as React from "react";
import { endOfDay, format } from "date-fns";

import { CalendarIcon, CamIcon, HospitalIcon } from "../../shared/svgIcon";
import {
  cn,
  dateConvert,
  useAppointmentsMiscellaneous,
} from "../../shared/utils";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { useRef } from "react";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Textarea } from "../ui/textArea";
import { useForm } from "react-hook-form";
import { useStore } from "../../store";

export function AppointmentForm1(props) {
  let navigate = useNavigate();
  const { locationId: id } = useParams();
  const { data: appointmentsMisc } = useAppointmentsMiscellaneous();
  const setSelectedAppointment = useStore((state) => state.setAppointment);
  const selectedAppointment = useStore((state) => state.selectedAppointment);

  const [isLoading, setIsLoading] = React.useState(true);
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
  const selectedDateRef = useRef(null);
  const selectedTimeRef = useRef(null);
  const [availDates, setAvailDates] = React.useState([]);
  const [timeSlot, setTimeSlots] = React.useState([]);
  const [currentDoctor, setCurrentDoctor] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState(null);
  const [selectedType, setSelectedType] = React.useState(
    selectedAppointment?.appointment_type || ""
  );
  const [locationDetail, setLocationDetail] = React.useState(null);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (!id) return;
    // console.log(id, "id");
    const currentDoctor = sessionStorage.getItem("selectedDoctor")
      ? JSON.parse(sessionStorage.getItem("selectedDoctor"))
      : null;
    const currentLocation = sessionStorage.getItem("selectedLocation")
      ? JSON.parse(sessionStorage.getItem("selectedLocation"))
      : null;
    setLocationDetail(currentLocation);
    setCurrentDoctor(currentDoctor);
    setIsLoading(false);
  }, [id]);

  useEffect(() => {
    setValue("reason", selectedAppointment?.reason);
    setSelectedType(selectedAppointment?.appointment_type || "virtual_visit");
  }, [selectedAppointment]);

  const handleSelectAppointment = (type) => {
    sessionStorage.setItem("selectedType", JSON.stringify(type));
    setSelectedType(type);
  };

  useEffect(() => {
    if (selectedDateRef.current) {
      selectedDateRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedDate]);
  useEffect(() => {
    if (selectedTimeRef.current) {
      selectedTimeRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedTime]);
  const StarRating = ({ rating, totalStars = 5 }) => {
    return (
      <div>
        {/* {[...Array(totalStars)].map((_, index) => (
          <Star key={index} selected={index < rating} />
        ))} */}
        <span style={{ color: "orange", fontSize: "20px" }}>&#9733;</span>
        <span className="pl-2 pr-[2px]">{rating}</span>{" "}
        <span className="">Rating</span>
      </div>
    );
  };
  const gotoAppointmentSummary = () => {
    if (selectedType) {
      navigate(`/scheduleAppointment/${id}/1`);
    }
  };
  const handleGoBack = () => {
    navigate(-1);
  };

  const onSubmit = (data) => {
    if (selectedType && data.reason) {
      setSelectedAppointment({
        ...selectedAppointment,
        appointment_type: selectedType,
        reason: data.reason,
      });
      navigate(`/scheduleAppointment/${id}/1`);
    }
    // const form1 = {
    //   // age: +data.age,
    //   height: {
    //     value: +data?.height,
    //     unit: "cm",
    //   },
    //   weight: {
    //     value: +data?.weight,
    //     unit: "kg",
    //   },
    // }
    // sessionStorage.setItem('form1',JSON.stringify(form1))
    // console.log(form1, "payload");
    // nextStep()
  };
  return (
    <>
      <div className="bg-white min-sh-screen ">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white ">
            <div>
              <Link className="flex" to="#" onClick={handleGoBack}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                  />
                </svg>
                <div className="pl-2 flex-1 mt-0.5">
                  <h4 className="font-semibold text-sm">Back</h4>
                </div>
              </Link>
            </div>
          </div>
          <div
            className=" flex-1 overflow-hidden hideScroll  text-gray-500  flex flex-col py-16 p-4 "
            // style={{ height: "calc(100vh - 30px)" }}
          >
            {currentDoctor && !isLoading && (
              <>
                <div className="flex flex-col w-full  p-2 mt-1  shadow bg-neutral-100 rounded-[18px] border">
                  <div className="flex flex-row gap-4">
                    <div className="w-[100px] h-[100px] rounded-full overflow-hidden">
                      {currentDoctor?.basic_details?.profile.avatar_url ? (
                        <img
                          className="w-full h-full object-cover"
                          src={currentDoctor?.basic_details?.profile.avatar_url}
                          alt={currentDoctor?.basic_details?.username}
                        />
                      ) : (
                        <img
                          className="w-full h-full object-cover"
                          src={"../../../images/user.svg"}
                          alt={currentDoctor?.basic_details?.username}
                        />
                      )}
                    </div>
                    <div className="flex flex-col">
                      <h1 className="text-lg font-bold">
                        {currentDoctor?.basic_details?.name_prefix}{" "}
                        {currentDoctor?.basic_details?.profile.first_name}{" "}
                        {currentDoctor?.basic_details?.profile.middle_name}{" "}
                        {currentDoctor?.basic_details?.profile.last_name}
                      </h1>

                      <div className="flex">
                        {currentDoctor?.basic_details?.qualifications &&
                          currentDoctor?.basic_details?.qualifications.map(
                            (qualification, index) => (
                              <div key={index}>
                                <span
                                  key={index}
                                  className="text-neutral-500 text-sm font-normal"
                                >
                                  {qualification}
                                </span>{" "}
                                {index <
                                  currentDoctor?.basic_details?.qualifications
                                    .length -
                                    1 && <span className="pr-1">,</span>}
                              </div>
                            )
                          )}
                        {currentDoctor?.basic_details?.specialities &&
                          currentDoctor?.basic_details?.specialities.map(
                            (specialty, index) => (
                              <div key={index}>
                                <span className="pr-1">,</span>
                                <span
                                  key={index}
                                  className="text-neutral-500 text-sm font-normal "
                                >
                                  {specialty?.name}
                                </span>{" "}
                                {index <
                                  currentDoctor?.basic_details?.specialities
                                    .length -
                                    1 && <span className="pr-1">,</span>}
                              </div>
                            )
                          )}
                      </div>
                      <StarRating
                        rating={currentDoctor?.basic_details?.ratings}
                      />
                    </div>
                  </div>
                </div>
                <div className=" py-3 mt-1">
                  <div className="text-base font-semibold">
                    {locationDetail?.organization_details?.name}
                  </div>

                  <div className="">
                    <span className="pr-2">
                      {locationDetail?.organization_details?.location}{" "}
                    </span>
                    <span className="pr-2">
                      {locationDetail?.organization_details?.address?.street},
                    </span>
                    <span className="pr-2">
                      {locationDetail?.organization_details?.address?.city},
                    </span>
                    <span className="pr-2">
                      {locationDetail?.organization_details?.address?.state}
                    </span>

                    <span className="pr-2">
                      {
                        locationDetail?.organization_details?.address
                          ?.postal_code
                      }
                    </span>
                  </div>

                  {locationDetail?.organization_details?.contact?.filter(
                    (e) => e.type == "phone"
                  ).length > 0 && (
                    <div className="location-phone webmd-row">
                      Tel:{" "}
                      <a
                        href={`tel:${
                          locationDetail?.organization_details?.contact?.find(
                            (contact) => contact.type === "phone"
                          )?.value
                        }`}
                        className=""
                      >
                        {
                          locationDetail?.organization_details?.contact?.find(
                            (contact) => contact.type === "phone"
                          )?.value
                        }
                      </a>
                    </div>
                  )}
                </div>
                <div className="pt-5">
                  <div className="text-lg font-semibold mb-2">
                    Select Appointment Type
                  </div>
                  <div className="flex flex-1 justify-around space-x-4 mb-3">
                    {appointmentsMisc?.data?.result?.appointment_types?.map(
                      (e, index) => (
                        <div
                          key={index}
                          className={`relative flex flex-1 cursor-pointer  items-center rounded-[16px] border-2  py-2 px-4 text-center text-black text-lg bg-[#F4EEEF] ${
                            selectedType === e.key ? " border-primary" : ""
                          }`}
                          onClick={() => handleSelectAppointment(e.key)}
                        >
                          <div
                            className={` ${
                              selectedType === e.key ? "round" : ""
                            }`}
                          ></div>
                          <div className="absolute left-4">
                            {e.key == "virtual_visit" ? (
                              <CamIcon
                                width={"20px"}
                                height={"20px"}
                                className="text-black"
                              />
                            ) : (
                              <HospitalIcon
                                width={"20px"}
                                height={"20px"}
                                className="text-black"
                              />
                            )}
                          </div>
                          <div className="text-base font-semibold ml-8">
                            {e.value}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
                <div className="pt-5">
                  <div className="text-lg font-semibold mb-2">
                    Reason for the visit
                  </div>
                  <div className="flex flex-col flex-1 justify-around space-x-4 mb-3">
                    <Textarea
                      {...register("reason", {
                        required: true,
                      })}
                      className="min-h-[120px]  border-black"
                      placeholder="Type reason"
                    />
                    {errors.reason && (
                      <p className="py-2 text-xs text-red-500">{"required"}</p>
                    )}
                  </div>
                </div>
              </>
            )}
            {isLoading && (
              <>
                <div className=" w-full bg-white p-2 mt-1 rounded shadow">
                  <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                    <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                    <div className="flex flex-col w-full">
                      <div className="m-2 w-full  bg-slate-200 h-4"></div>
                      <div className="m-2  w-full  bg-slate-200 h-4"></div>
                    </div>
                  </div>
                </div>

                <div className="relative">
                  <div className="mb-4 text-xs border-b  mt-2 bg-white rounded shadow">
                    <div className="animate-pulse flex flex-col cursor-pointer p-1 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                      <div className=" w-full  bg-slate-200 h-8"></div>
                    </div>
                  </div>

                  <div
                    className="overflow-scroll hideScroll flex flex-col gap-3"
                    style={{ height: "calc(100vh - 250px)" }}
                  >
                    <div className="animate-pulse flex flex-col  cursor-pointer p-4 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                      <div className="m-2 w-full  bg-slate-200 h-4"></div>
                      <div className="m-2  w-full  bg-slate-200 h-4"></div>
                    </div>
                    <div className="animate-pulse flex flex-col cursor-pointer p-4 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                      <div className="m-2 w-full  bg-slate-200 h-4"></div>
                      <div className="m-2  w-full  bg-slate-200 h-4"></div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="bg-white h-16 fixed bottom-0 w-full pt-1 flex justify-center">
            <button
              type="submit"
              // onClick={gotoAppointmentSummary}
              className="  w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold"
            >
              Book appointment
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
